function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

// 城市列表
export function cityList(data) {
  return request({
    url: '/admin/system/city/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 城市列表-两层
export function cityListTree2() {
  return request({
    url: '/admin/system/city/list/treeLevel2',
    method: 'get'
  });
}

// 城市列表
export function cityListTree() {
  return request({
    url: '/admin/system/city/list/tree',
    method: 'get'
  });
}
export function treeLevel3() {
  return request({
    url: '/admin/system/city/list/treeLevel3',
    method: 'get'
  });
}

// 获取四川地区的三级树结构列表
export function treeLevel3ForSichuan() {
  return request({
    url: '/admin/system/city/list/treeLevel3ForSichuan',
    method: 'get'
  });
}

// 城市修改状态
export function updateStatus(data) {
  return request({
    url: '/admin/system/city/update/status',
    method: 'post',
    params: _objectSpread({}, data)
  });
}

// 城市修改
export function cityUpdate(data) {
  return request({
    url: '/admin/system/city/update',
    method: 'post',
    params: _objectSpread({}, data)
  });
}

// 城市详情
export function cityInfo(data) {
  return request({
    url: '/admin/system/city/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流公司列表
export function expressList(data) {
  return request({
    url: '/admin/express/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 同步物流公司
export function expressSyncApi() {
  return request({
    url: '/admin/express/sync/express',
    method: 'post'
  });
}

// 物流公司修改状态
export function expressUpdateShow(data) {
  return request({
    url: '/admin/express/update/show',
    method: 'post',
    data: data
  });
}

// 物流公司 编辑
export function expressUpdate(data) {
  return request({
    url: '/admin/express/update',
    method: 'post',
    data: data
  });
}

// 新增物流公司
export function expressSave(data) {
  return request({
    url: '/admin/express/save',
    method: 'post',
    params: _objectSpread({}, data)
  });
}

// 删除物流公司
export function expressDelete(data) {
  return request({
    url: '/admin/express/delete',
    method: 'GET',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板列表
export function shippingTemplatesList(data) {
  return request({
    url: '/admin/express/shipping/templates/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 商户物流运费模板列表
export function merchantExpressList(data) {
  return request({
    url: '/admin/express/shipping/templates/merchantExpressList',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板详情
export function templateDetailApi(data) {
  return request({
    url: '/admin/express/shipping/templates/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板详情
export function merchantExpressInfo(data) {
  return request({
    url: '/admin/express/shipping/templates/merchantExpressInfo',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板包邮
export function shippingFree(data) {
  return request({
    url: '/admin/express/shipping/free/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板不包邮
export function shippingRegion(data) {
  return request({
    url: 'admin/express/shipping/region/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 物流运费模板新增
export function shippingSave(data) {
  return request({
    url: 'admin/express/shipping/templates/save',
    method: 'post',
    data: data
  });
}

// 物流运费模板新增(商户)
export function merchantExpressSave(data) {
  return request({
    url: 'admin/express/shipping/templates/merchantExpressSave',
    method: 'post',
    data: data
  });
}

// 物流运费模板更新
export function shippingUpdate(data, id) {
  return request({
    url: 'admin/express/shipping/templates/update',
    method: 'post',
    data: data,
    params: _objectSpread({}, id)
  });
}

// 物流运费模板更新（商户）
export function merchantExpressUpdate(data, id) {
  return request({
    url: 'admin/express/shipping/templates/merchantExpressUpdate',
    method: 'post',
    data: data,
    params: _objectSpread({}, id)
  });
}

// 物流运费模板删除
export function shippingDetete(data) {
  return request({
    url: 'admin/express/shipping/templates/delete',
    method: 'get',
    params: data
  });
}

// 物流运费模板删除（商户）
export function merchantExpressDelete(data) {
  return request({
    url: 'admin/express/shipping/templates/merchantExpressDelete',
    method: 'get',
    params: data
  });
}

// 物流公司详情
export function expressInfo(data) {
  return request({
    url: 'admin/express/info',
    method: 'get',
    params: _objectSpread({}, data)
  });
}